export interface Pagination {
  pageNumber: number;
  pageSize?: number;
  totalPages?: number;
  totalItems?: number;
}
